import { gql } from '@apollo/client';

export const fetchAddOns = gql`
  query fetchAddOns(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        billingFrequency
        productId
        createdDate
        baseProduct
        billingStatus
        entitlementNumber
        productName
        billingCycle
        transactionAccountId
        latestPeriodEndDate
        lastPeriodStartDate
        activeUsers
        userTier
        trial
        provisioningStatus
        chargeElement
        isAddOn
        isFutureDatedSubscription
        nextBillEstimate {
          total
          currency
        }
        offering {
          id
          name
        }
      }
    }
  }
`;
